/** Canonical numeric plugin step alignment. Byte-mirrored into web/lib/pluginNumber.ts. */
export function isStepAligned(value: number, base: number, step: number): boolean {
  const nearest = base + Math.round((value - base) / step) * step;
  const tolerance = Number.EPSILON * Math.max(1, Math.abs(value), Math.abs(base), Math.abs(step), Math.abs(nearest)) * 8;
  return Math.abs(value - nearest) <= tolerance;
}
